import React from 'react'
import { FormCheckbox } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'
import {
  getMostRecentFieldValue,
  getNestedSubelementsByType,
  getPersonGivenName,
  getPersonName,
  useSlsHighlightsContext,
} from '@fs/zion-sls'
import useNamesExperienceOptIn from '../../../../../../hooks/useNamesExperienceOptIn'
import FieldWrapper from '../../../uiHelpers/FieldWrapper'
import { useR2StateContext } from '../../../../../../providers/r2Provider/R2Context'

const SharedHighlightPersonCheckbox = ({ person, fieldValue, disabled, isNewPerson }) => {
  const [t] = useTranslation()
  const r2State = useR2StateContext()
  const newPerson = t('add-highlight-linked-fields.new-person', 'New person')
  const { activeFieldInfo } = useSlsHighlightsContext()
  const noRelationship = t('add-highlight-linked-fields.no-relationship', 'No relationship')
  const { isOptedIn } = useNamesExperienceOptIn()
  const wrapperSize = isOptedIn ? '400px' : undefined

  const isSelectedPerson =
    r2State.selectedPersonId === person.id || (isNewPerson && activeFieldInfo?.personId === person.id)

  const relationshipToHead = getNestedSubelementsByType(person, 'RELATIONSHIP_TO_HEAD')?.[0]

  const personFullName =
    isSelectedPerson && activeFieldInfo?.fieldType === 'NAME_SURN'
      ? `${getPersonGivenName(person)} ${fieldValue?.displayValue || fieldValue}`.trim()
      : getPersonName({ person })

  let relationshipToHeadValue = getMostRecentFieldValue(relationshipToHead)
  if (!relationshipToHeadValue) relationshipToHeadValue = isNewPerson && isSelectedPerson ? newPerson : noRelationship

  return (
    <FieldWrapper key={person.id} size={wrapperSize} maxWidth={wrapperSize}>
      <FormCheckbox
        disabled={isSelectedPerson || disabled}
        checked={isSelectedPerson}
        name={person.id || 'SOME-TEMP-ID'}
        value={person.id || 'SOME-TEMP-ID'}
        label={`${personFullName} ${relationshipToHeadValue ? `(${relationshipToHeadValue})` : ''}`}
      />
    </FieldWrapper>
  )
}

export default SharedHighlightPersonCheckbox
